import React, { useState } from 'react';
import axios from 'axios';
import { apiErrorMessage } from '../apiError';

function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    try {
  await axios.post(`${process.env.REACT_APP_API_URL}/users/signup`, {
    email,
    password,
  });
  // auto-login after signup
  const loginResponse = await axios.post(`${process.env.REACT_APP_API_URL}/users/login`, {
    email,
    password,
  });
  const { access_token } = loginResponse.data;
  localStorage.setItem('token', access_token);
  localStorage.setItem('userEmail', email);
  // new user has no filings so go straight to landing page
  const signupParams = new URLSearchParams(window.location.search);
const town = signupParams.get('town');
const townCode = signupParams.get('town_code');
const formType = signupParams.get('form_type');
if (town && townCode && formType) {
  window.location.href = `/page1?fiscal_year=${new Date().getFullYear()}&town=${town}&town_code=${townCode}&form_type=${formType}`;
} else {
  window.location.href = '/';
}
} catch (err) {
  setError(apiErrorMessage(err, 'Could not create account. Please try again in a moment.'));
}
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>MAtownforms</h1>
        <h2 style={styles.subtitle}>Create Account</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Confirm Password</label>
            <input
              style={styles.input}
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>
          <button style={styles.button} type="submit">Create Account</button>
        </form>
        <p style={styles.link}>
          Already have an account?{' '}
          <a href="/login" style={styles.anchor}>Sign in</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '420px',
  },
  title: {
  color: '#1a3a5c',
  fontSize: '42px',
  fontWeight: '700',
  fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  marginBottom: '8px',
  textAlign: 'center',
},
  subtitle: {
    color: '#444',
    fontSize: '18px',
    marginBottom: '24px',
    textAlign: 'center',
  },
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    color: '#333',
    fontSize: '14px',
    fontWeight: '600',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  error: {
    color: '#cc0000',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  link: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '14px',
    color: '#555',
  },
  anchor: {
    color: '#1a3a5c',
    fontWeight: '600',
  },
};

export default Signup;